// timer
export const START_TIMER = 'START_TIMER'
export type START_TIMER = typeof START_TIMER

export const STOP_TIMER = 'STOP_TIMER'
export type STOP_TIMER = typeof STOP_TIMER

// view
export const CHANGE_VIEW = 'CHANGE_VIEW'
export type CHANGE_VIEW = typeof CHANGE_VIEW

// animationId
export const INCREMENT_ID = 'INCREMENT_ID'
export type INCREMENT_ID = typeof INCREMENT_ID

export const RESET_ID = 'RESET_ID'
export type RESET_ID = typeof RESET_ID

export const SET_ID = 'SET_ID'
export type SET_ID = typeof SET_ID

// snapshot
export const POST_SNAPSHOT = 'POST_SNAPSHOT'
export type POST_SNAPSHOT = typeof POST_SNAPSHOT

export const POST_SNAPSHOT_REQUEST = 'POST_SNAPSHOT_REQUEST'
export type POST_SNAPSHOT_REQUEST = typeof POST_SNAPSHOT_REQUEST

export const POST_SNAPSHOT_SUCCESS = 'POST_SNAPSHOT_SUCCESS'
export type POST_SNAPSHOT_SUCCESS = typeof POST_SNAPSHOT_SUCCESS

export const POST_SNAPSHOT_FAIL = 'POST_SNAPSHOT_FAIL'
export type POST_SNAPSHOT_FAIL = typeof POST_SNAPSHOT_FAIL



// WEBPACK FOOTER //
// ./src/constants/index.ts